export default __webpack_public_path__ + "static/media/ASPA_PARTNER_FOCUS_6.31c0a337.png";